import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {config} from "../../../config";

@Injectable()
export default class HttpBaseUrlInterceptor implements HttpInterceptor {
  public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    if (!req.url.startsWith('/')) {
      return next.handle(req);
    }

    const baseUrl: string = config.baseUrl;
    const url: string = `${baseUrl}${req.url}`;

    const RequestWithCredentials: HttpRequest<unknown> = req.clone({
      url,
      withCredentials: true
    });

    return next.handle(RequestWithCredentials);
  }
}
